export const SITE_URL = "https://useit.se/";
export const COMPANY_NAME = "Useit";
export const ENGLISH = "English";
export const SWEDISH = "Svenska";
export const NORWEGIAN = "Norsk";
export const DANISH = "Dansk";
